document.addEventListener('DOMContentLoaded', function() {
  initializeCardProducts();
});

function initializeCardProducts() {
  const productCards = document.querySelectorAll('.card__information');
  productCards.forEach(card => {
    const dropdown = card.querySelector('.variant-dropdown');
    if (dropdown) updateCardState(dropdown);
  });
}

// function updateCardState(element) {
//   const cardSection = element.closest('.card__information');
//   const variantDropdown = cardSection.querySelector('.variant-dropdown');
//   const glutenFreeCheckbox = cardSection.querySelector('.gluten-free-checkbox');
//   const addToCartBtn = cardSection.querySelector('.add-to-cart-btn');

//   if (!addToCartBtn || !variantDropdown) return;

//   const selectedOption = variantDropdown.options[variantDropdown.selectedIndex];
//   if (!selectedOption) return;

//   const variantPriceCents = parseFloat(selectedOption.dataset.price || 0);
//   const isAvailable = selectedOption.dataset.available === 'true';

//   let addonPriceCents = 0;
//   if (glutenFreeCheckbox && glutenFreeCheckbox.checked) {
//     addonPriceCents = parseFloat(glutenFreeCheckbox.dataset.addonPrice || 0);
//   }

//   const totalCents = variantPriceCents + addonPriceCents;
//   const totalDollars = totalCents / 100;
//   const formattedPrice = formatCurrency(totalDollars);
  
//   if (isAvailable) {
//     addToCartBtn.textContent = `Add to Cart - ${formattedPrice}`;
//     addToCartBtn.disabled = false;
//   } else {
//     addToCartBtn.textContent = `Sold Out - ${formattedPrice}`;
//     addToCartBtn.disabled = true;
//   }
// }
function updateCardState(element) {
  // 1. Locate the parent container
  const cardSection = element.closest('.card__information');
  if (!cardSection) return; // Safety check if parent isn't found

  // 2. locate necessary child elements
  const variantDropdown = cardSection.querySelector('.variant-dropdown');
  const addToCartBtn = cardSection.querySelector('.add-to-cart-btn');

  // Safety check: ensure elements exist before proceeding
  if (!addToCartBtn || !variantDropdown) return;

  // 3. Get the currently selected option from the dropdown
  const selectedOption = variantDropdown.options[variantDropdown.selectedIndex];
  if (!selectedOption) return;

  // 4. Get data from data attributes (Price & Availability)
  // Assuming data-price is in cents (e.g., "1999" for $19.99)
  const variantPriceCents = parseFloat(selectedOption.dataset.price || 0);
  const isAvailable = selectedOption.dataset.available === 'true';

  // 5. Calculate Price
  const totalDollars = variantPriceCents / 100;
  
  // Note: Ensure formatCurrency is defined in your project. 
  // I have included a basic version below.
  const formattedPrice = formatCurrency(totalDollars);

  // 6. Update the button
  if (isAvailable) {
    // FIX: Use innerHTML to render the <span> tags correctly
    addToCartBtn.innerHTML = `<span>Add to Cart</span> <span>${formattedPrice}</span>`;
    addToCartBtn.disabled = false;
    addToCartBtn.classList.remove('disabled'); // Optional visual cue
  } else {
    addToCartBtn.innerHTML = `<span>Sold Out</span> <span>${formattedPrice}</span>`;
    addToCartBtn.disabled = true;
    addToCartBtn.classList.add('disabled'); // Optional visual cue
  }
}

// Helper function example (if you don't have one already)
function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
}

function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(amount);
}

function addToCartWithAddon(event) {
  event.preventDefault();
  const btn = event.target;
  const cardSection = btn.closest('.card__information');
  const dropdown = cardSection.querySelector('.variant-dropdown');
  const glutenFreeCheckbox = cardSection.querySelector('.gluten-free-checkbox');

  if (btn.disabled) return;

  const mainVariantId = dropdown.value;
  if (!mainVariantId) {
    alert("Please select a variant.");
    return;
  }

  const hasAddon = glutenFreeCheckbox && glutenFreeCheckbox.checked;
  
  const items = [{
    id: Number(mainVariantId),
    quantity: 1
  }];

  if (hasAddon) {
    const addonId = glutenFreeCheckbox.dataset.addonId;
    if(addonId) {
      items.push({ id: Number(addonId), quantity: 1 });
    }
  }

  const originalText = btn.textContent;
  btn.textContent = 'Adding...';

  // 1. Try Adding Both
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(response => response.json().then(data => {
    if (response.ok) return data;
    throw data;
  }))
  .then(data => {
    btn.textContent = 'Added!';
    window.location.href = '/cart';
  })
  .catch(errorData => {
    console.warn('Batch add failed:', errorData);

    // 2. Fallback: Add items one by one to find the specific error
    if (hasAddon) {
      btn.textContent = 'Retry...';
      
      // Step A: Add Main Item
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(mainVariantId), quantity: 1 }] })
      })
      .then(r => r.json().then(d => { if(r.ok) return d; throw d; }))
      .then(() => {
        // Step B: Main item succeeded, now try Add-on alone
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(glutenFreeCheckbox.dataset.addonId), quantity: 1 }] })
        });
      })
      .then(r => r.json().then(d => { 
          if(r.ok) {
            window.location.href = '/cart'; 
          } else {
            alert("Main Item added, but Add-on failed from Shopify: " + (d.description || "Unknown Inventory Error"));
            window.location.href = '/cart';
          }
      }))
      .catch(finalError => {
         const err = finalError.description || "Unknown Error";
         alert("Could not add to cart: " + err);
         setTimeout(() => { btn.textContent = originalText; }, 2000);
      });
      
    } else {
      const err = errorData.description || "Unknown Error";
      alert("Error: " + err);
      setTimeout(() => { btn.textContent = originalText; }, 2000);
    }
  });
}


// Cart Drawer code 
document.addEventListener('DOMContentLoaded', () => {

  /* ===============================
     REFRESH CART DRAWER SECTIONS
  ================================ */
  function refreshCartSections() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(res => res.json())
      .then(data => {
        const parser = new DOMParser();
        const html = parser.parseFromString(data['cart-drawer'], 'text/html');

        /* Cart Items */
        const newItems = html.querySelector('#CartDrawer-CartItems');
        const oldItems = document.querySelector('#CartDrawer-CartItems');
        if (newItems && oldItems) oldItems.replaceWith(newItems);

        /* Header */
        const newHeader = html.querySelector('.drawer__header');
        const oldHeader = document.querySelector('.drawer__header');
        if (newHeader && oldHeader) oldHeader.replaceWith(newHeader);

        /* Footer */
        const newFooter = html.querySelector('.drawer__footer');
        const oldFooter = document.querySelector('.drawer__footer');
        if (newFooter && oldFooter) oldFooter.replaceWith(newFooter);

        /* Empty drawer handling */
        const emptyState = document.querySelector('.drawer__inner-empty');
        const drawer = document.querySelector('cart-drawer');
        const cartdraweritems = document.querySelector('cart-drawer-items');
        const cartdraweritems_body = document.querySelector('body');

        if (newItems && newItems.children.length > 0) {
          if (emptyState) emptyState.style.display = 'none';
          drawer.classList.remove('is-empty');
          cartdraweritems_body.classList.add('overflow-hidden');
          cartdraweritems.classList.remove('is-empty');
        } else {
          if (emptyState) emptyState.style.display = 'block';
          cartdraweritems_body.classList.remove('overflow-hidden');
          drawer.classList.add('is-empty');
        }
      });
  }

  /* ===============================
     ADD TO CART WITH ADDON
  ================================ */
  window.addToCartWithAddon = async function (event) {
    event.preventDefault();

    const button = event.currentTarget;
    const card = button.closest('.card');
    if (!card) return;

    const variantSelect = card.querySelector('.variant-dropdown');
    const addonCheckbox = card.querySelector('.gluten-free-checkbox');

    const mainVariantId = variantSelect?.value;
    const addonVariantId = addonCheckbox?.checked
      ? addonCheckbox.dataset.addonId
      : null;

    if (!mainVariantId) {
      alert('You have reached available item limit');
      return;
    }

    const items = [{ id: Number(mainVariantId), quantity: 1 }];

    if (addonVariantId) {
      items.push({ id: Number(addonVariantId), quantity: 1 });
    }

    button.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      const cart = await fetch('/cart.js').then(r => r.json());

      let bubble = document.querySelector('.cart-count-bubble');

      if (!bubble && cart.item_count > 0) {
        const cartIcon = document.querySelector('.header__icon--cart');
        if (cartIcon) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          cartIcon.appendChild(bubble);
        }
      }

      if (bubble) bubble.textContent = cart.item_count;


      if (!res.ok) {
        alert('You have reached available item limit');
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      const drawer = document.querySelector('cart-drawer');
      drawer?.classList.add('active', 'animate');

      await refreshCartSections();



    } catch (e) {
      console.error('Add to cart failed', e);
      alert('You have reached available item limit');
    } finally {
      button.disabled = false;
    }
  };

});


// Varient image chnage and checkbox visibility code 
  document.addEventListener('change', function (e) {
    const select = e.target.closest('.variant-dropdown');
    if (!select) return;

    const card = select.closest('.card');
    const img = card?.querySelector('.product-card-image');
    console.log("img", img)
    if (!img) return;

    const option = select.options[select.selectedIndex];
    const variantImage = option.dataset.image;
    console.log("variantImage", variantImage)

    img.src = variantImage || img.dataset.defaultSrc;
  });
  document.addEventListener('change', e => {
    const s = e.target.closest('.variant-dropdown');
    if (!s) return;
    
    const c = s.closest('.card');
    const a = c.querySelector('.addon-option');
    const ch = a?.querySelector('input');
    
    if (ch) ch.checked = false;
    if (a) a.style.visibility = /cake/i.test(s.options[s.selectedIndex].text) ? 'hidden' : 'visible';
  });
